// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".platform-users-container {\n  margin-top: 20px;\n}", "",{"version":3,"sources":["webpack://./app/javascript/components/platformUsers/platformUsers.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF","sourcesContent":[".platform-users-container {\n  margin-top: 20px;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
